var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass:
        "is-flex is-align-items-center is-justify-content-center designed-button has-text-weight-bold is-clickable",
    },
    [_c("span", [_vm._v(" " + _vm._s(_vm.value) + " ")])]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }